import { useEffect, useState } from 'react';
import { FEATURES_LIST } from '../../utils/featuresOptions';

import styles from './FeaturesBlock.module.scss';

import { SelectState } from '../../redux/types/bookingTypes';
import FilterBanner from '../BookingListComponents/FilterBanner';
import { useDispatch, useSelector } from 'react-redux';
import { setModalWindowData } from '../../redux/reducers/pageSlice';
import {
  ButtonType,
  InputType,
  ModalWindowTypes,
} from '../../utils/@globalTypes';
import { RentalObjectSelectors } from '../../redux/reducers/rentalObjectSlice';
import Button from '../Button';
import { EditIcon } from '../../assets/icons';
import Input from '../Input';
import useWindowDimensions from '../../utils/useWindowDimensions';

const FeaturesBlock = () => {
  const currentFeaturesList = useSelector(
    RentalObjectSelectors.getCurrentFeaturesList,
  );
  const { width } = useWindowDimensions();
  const [features, setFeatures] = useState<SelectState[]>([]);
  const emptySelect = 'Выберите удобства';

  const getRussianTitleForFeatures = (logo: string) => {
    for (const item of FEATURES_LIST) {
      const feat = item.list.find((feat) => feat.logo === logo);
      if (feat) {
        return feat.title;
      }
    }
    return '';
  };
  const initialSelect = () => {
    // начальный стейт для списка объектов
    const start: SelectState[] = [];

    FEATURES_LIST.forEach((listItem) => {
      listItem.list.forEach((item) => {
        const index =
          currentFeaturesList.length > 0
            ? currentFeaturesList.findIndex((feat) => feat.logo === item.logo)
            : -1;
        const isChecked = index > -1 ? true : false;

        start.push({ id: item.logo, checked: isChecked });
      });
    });

    setFeatures(start);
  };

  useEffect(() => {
    initialSelect();
  }, []);

  const filterBanners = features.filter((item) => item.checked);
  const displayBanners =
    filterBanners.length > 0 &&
    filterBanners.map((item) => {
      const title = getRussianTitleForFeatures(item.id);
      return <FilterBanner key={Math.random()} title={title} />;
    });
  const countFeatForTitle = width > 580 ? 3 : width > 460 ? 2 : 1;

  let innerTitle: string = '';

  if (filterBanners.length > 0) {
    const title: string[] = [];
    const featSlice = filterBanners.slice(0, countFeatForTitle);
    featSlice.forEach((item, index) => {
      title.push(getRussianTitleForFeatures(item.id));
      index < countFeatForTitle - 1 &&
        index < featSlice.length - 1 &&
        title.push(', ');
    });
    if (filterBanners.length > countFeatForTitle) {
      const count = filterBanners.length - countFeatForTitle;
      title.push(` и еще ${count} ...`);
    }
    innerTitle = title.join('');
  }

  const dispatch = useDispatch();

  const handlerFeatures = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_FEATURES,
        data: {
          list: features,
          setList: setFeatures,
        },
      }),
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.btnLine}>
        <div onClick={handlerFeatures}>
          <Input
            placeholder={emptySelect}
            type={InputType.TEXT}
            value={innerTitle}
            onChange={handlerFeatures}
          />
        </div>
        <Button
          type={ButtonType.SMALL}
          title={<EditIcon />}
          onClick={handlerFeatures}
        />
      </div>
      <div className={styles.bnrs}>{displayBanners}</div>
    </div>
  );
};

export default FeaturesBlock;
